/*-----------------------------------------------------------------
- Helpers Mixin
-----------------------------------------------------------------*/
export default {
    name   : 'HelpersMixin',
    methods: {
        /**
         * Show title and find $ char for change COLOR
         *
         * @param {string} text
         * @returns {string}
         */
        titleGenerator(text) {
            return text.replace(/\$(.*?)\$/g, '<span class="color-primary">$1</span>');
        },
    },
};
